// Hero skills: bonuses unlocked automatically at hero level thresholds.
import { HEROES, type HeroDef, type HeroSkill } from '../data/heroes';
import type { ModifierSource } from './stats';

export function heroSkillSource(): ModifierSource {
  return {
    id: 'heroSkills',
    apply(state, m) {
      for (const hero of HEROES) {
        const level = state.heroLevels[hero.id] ?? 0;
        if (level <= 0) continue;
        for (const { level: need, effect: e } of hero.skills) {
          if (level < need) break; // skills are sorted by level
          switch (e.kind) {
            case 'self': m.mult(`heroSelf.${hero.id}`, e.mult); break;
            case 'all': m.mult('allDamage', e.mult); break;
            case 'type': m.mult(`heroDamage.${hero.type}`, e.mult); break;
            case 'tap': m.mult('tapDamage', e.mult); break;
            case 'gold': m.mult('gold', e.mult); break;
            case 'critDamage': m.mult('critDamage', e.mult); break;
            case 'bossDamage': m.mult('bossDamage', e.mult); break;
          }
        }
      }
    },
  };
}

/** Skills whose threshold lies in (from, to]. */
export function skillsCrossed(hero: HeroDef, from: number, to: number): HeroSkill[] {
  return hero.skills.filter((s) => s.level > from && s.level <= to);
}

export function nextSkill(hero: HeroDef, level: number): HeroSkill | undefined {
  return hero.skills.find((s) => s.level > level);
}

/** Product of a hero's own "self" skill multipliers at `level`. */
export function selfSkillMult(hero: HeroDef, level: number): number {
  let m = 1;
  for (const s of hero.skills) if (s.level <= level && s.effect.kind === 'self') m *= s.effect.mult;
  return m;
}
